
import CompanyFormationHero from "../components/CompanyFormationHero";
import CompanyFormationServices from "../components/CompanyFormationServices";
import CompanyFormationBenefits from "../components/CompanyFormationBenefits";
import CompanyFormationStats from "../components/CompanyFormationStats";
import CompanyFormationCTA from "../components/CompanyFormationCTA";

const CompanyFormation = () => {
  return (
    <div className="min-h-screen bg-background">
      <CompanyFormationHero />
      <CompanyFormationServices />
      <CompanyFormationBenefits />
      <CompanyFormationStats />
      <CompanyFormationCTA />
    </div>
  );
};

export default CompanyFormation;
